export const brands = [
  // Popular
  { id: "ohuhu", name: "Ohuhu", type: "Alcohol Markers", typeFr: "Marqueurs a Alcool", popular: true },
  { id: "copic", name: "Copic", type: "Alcohol Markers", typeFr: "Marqueurs a Alcool", popular: true },
  { id: "prismacolor_pencils", name: "Prismacolor Pencils", type: "Colored Pencils", typeFr: "Crayons de Couleur", popular: true },

  // Standard
  { id: "prismacolor_markers", name: "Prismacolor Markers", type: "Alcohol Markers", typeFr: "Marqueurs a Alcool", popular: false },
  { id: "faber_castell", name: "Faber-Castell", type: "Colored Pencils", typeFr: "Crayons de Couleur", popular: false },
  { id: "polychromos", name: "Polychromos", type: "Colored Pencils", typeFr: "Crayons de Couleur", popular: false },
  { id: "tombow", name: "Tombow", type: "Brush Pens", typeFr: "Feutres Pinceaux", popular: false },
  { id: "winsor_newton", name: "Winsor & Newton", type: "Pro Markers", typeFr: "Marqueurs Pro", popular: false },

  // Subtle
  { id: "arteza", name: "Arteza", type: "Mixed", typeFr: "Mixte", popular: false, subtle: true },
  { id: "crayola", name: "Crayola", type: "Basic", typeFr: "Basique", popular: false, subtle: true },
  { id: "other", name: "Other / Mixed", nameFr: "Autre / Mixte", type: "Various", typeFr: "Divers", popular: false, subtle: true, legacy: true },

  // Finishing
  { id: "acrylic_white", name: "Acrylic White / Gel Pen", nameFr: "Acrylique Blanc / Gel Pen", type: "Finishing", typeFr: "Finition", popular: false, isFinishing: true }
];

export const CUSTOM_BRAND_PREFIX = "custom:";

export function normalizeBrandInput(value) {
  return String(value || "").replace(/\s+/g, " ").trim();
}

export function getBrandById(id) {
  return brands.find((brand) => brand.id === id) || null;
}

export function isCustomBrandId(value) {
  return typeof value === "string" && value.startsWith(CUSTOM_BRAND_PREFIX);
}

export function getCustomBrandLabel(value) {
  if (!isCustomBrandId(value)) {
    return normalizeBrandInput(value);
  }

  return normalizeBrandInput(value.slice(CUSTOM_BRAND_PREFIX.length));
}

export function createCustomBrandId(value) {
  const normalized = normalizeBrandInput(value);
  return normalized ? `${CUSTOM_BRAND_PREFIX}${normalized}` : "";
}

export function findBrandIdByName(value) {
  const normalized = normalizeBrandInput(value).toLowerCase();
  if (!normalized) return null;

  const match = brands.find((brand) =>
    !brand.legacy &&
    [brand.name, brand.nameFr]
      .filter(Boolean)
      .some((label) => normalizeBrandInput(label).toLowerCase() === normalized)
  );

  return match?.id || null;
}

export function getBrandLabel(id, language = "en") {
  const brand = getBrandById(id);
  if (brand) {
    return language === "fr" ? brand.nameFr || brand.name : brand.name;
  }

  return getCustomBrandLabel(id);
}

export function normalizeSelectedBrands(values = []) {
  const input = Array.isArray(values) ? values : [];
  const seen = new Set();
  const normalized = [];

  for (const rawValue of input) {
    if (typeof rawValue !== "string") continue;

    const trimmedValue = rawValue.trim();
    if (!trimmedValue) continue;

    let nextValue = null;

    if (getBrandById(trimmedValue)) {
      nextValue = trimmedValue;
    } else if (isCustomBrandId(trimmedValue)) {
      const customLabel = getCustomBrandLabel(trimmedValue);
      const matchedBrandId = findBrandIdByName(customLabel);
      nextValue = matchedBrandId || createCustomBrandId(customLabel);
    } else {
      const matchedBrandId = findBrandIdByName(trimmedValue);
      nextValue = matchedBrandId || createCustomBrandId(trimmedValue);
    }

    if (!nextValue) continue;

    const dedupeKey = getBrandById(nextValue)
      ? `brand:${nextValue}`
      : `custom:${getCustomBrandLabel(nextValue).toLowerCase()}`;

    if (seen.has(dedupeKey)) continue;
    seen.add(dedupeKey);
    normalized.push(nextValue);
  }

  return normalized;
}

export function getCustomSelectedBrands(values = []) {
  return normalizeSelectedBrands(values).filter((brandId) => {
    const brand = getBrandById(brandId);
    return isCustomBrandId(brandId) || Boolean(brand?.legacy);
  });
}
